import React from 'react'
import T from './Translation';

const Footer = () => {
        const thisYear = new Date().getFullYear();
        return (
          <div className='footer'>
            <img src="/reMindLogo.png" alt="reMind Logo" style={{ height: '80px' }} />
              <T obj = {{
                  en: <>  
                    reMind is intended to be used as a complementary tool, under the supervision of qualified professionals. <br/>
                    It is not a medical device, and it does not offer healing, treatment, or cures for any health condition.  <br/>
                    Always consult with a healthcare professional for medical advice.
                    <br/><br/>
                  </>,
                  it: <>  
                    reMind è stato realizzato come strumento complementare, sotto la supervisione di professionisti qualificati.  <br/>
                    Non è un dispositivo medico e non offre guarigione, trattamento o cure per alcuna condizione di salute.  <br/>
                    Consultare sempre un professionista sanitario per consigli medici.
                    <br/><br/>
                  </>
                }}/>
            <p>Copyright © {thisYear} Your Mind Up Ltd. All rights reserved.</p>
          </div>
      
        )
}

export default Footer
